import React from 'react'
import { Box, Grid, Skeleton, Divider, Stack } from '@mui/material'

const BeneficiaryFormSkeleton = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Grid container spacing={2} alignItems='center'>
        <Grid item xs={12} md={4}>
          <Skeleton variant='text' width={120} height={25} />
          <Skeleton variant='rounded' height={40} />
        </Grid>
        <Grid item xs={12} md={6}>
          <Skeleton variant='text' width={180} height={25} />
          <Skeleton variant='rounded' height={40} />
        </Grid>
        <Grid item xs={12} md={2}>
          <Skeleton variant='rounded' height={40} />
        </Grid>
      </Grid>

      <Divider sx={{ my: 4 }} />

      <Grid container spacing={2}>
        {Array.from({ length: 12 }).map((_, i) => (
          <Grid item xs={12} md={3} key={`personal-${i}`}>
            <Skeleton variant='text' width={100} height={20} />
            <Skeleton variant='rounded' height={40} />
          </Grid>
        ))}
      </Grid>

      <Divider sx={{ my: 4 }} />

      <Grid container spacing={2}>
        {Array.from({ length: 12 }).map((_, i) => (
          <Grid item xs={12} md={3} key={`insurance-${i}`}>
            <Skeleton variant='text' width={100} height={20} />
            <Skeleton variant='rounded' height={40} />
          </Grid>
        ))}
      </Grid>

      <Divider sx={{ my: 4 }} />

      <Grid container spacing={2}>
        {Array.from({ length: 3 }).map((_, i) => (
          <Grid item xs={12} md={4} key={`coverage-${i}`}>
            <Skeleton variant='text' width={100} height={20} />
            <Skeleton variant='rounded' height={40} />
          </Grid>
        ))}
      </Grid>

      <Divider sx={{ my: 4 }} />

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
        <Skeleton variant='circular' width={24} height={24} />
        <Skeleton variant='text' width={120} height={30} />
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 2
        }}
      >
        <Skeleton variant='rounded' width={160} height={40} />
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Skeleton variant='rounded' width={180} height={50} />
          <Skeleton variant='rounded' width={280} height={50} />
        </Box>
      </Box>
    </Box>
  )
}

export default BeneficiaryFormSkeleton
